/**
 * Created by Administrator on 2017/5/24.
 *   分页组件
 *   @param data={ "last": true,"totalElements": 11,"totalPages": 1,"number": 0,"size": 15,"first": true,"numberOfElements": 11 }
 *   @param page={pageNumber:1,pageSize:10}
 *   @event change function
 *   使用方法
 *   <pagination (change)="refresh()" [(page)]="page" [(data)]="data"></pagination>
 */
import { Component, Input, Output, EventEmitter,OnInit } from '@angular/core';
@Component({
  selector:'pagination',
  template:`
     <div class="page-all">
  <!--<ul class="page-left"><li (click)="refresh(page.pageNumber)"><span>refresh</span></li></ul>-->
  <ul class="page-center">
    <li class="page-first"><button (click)="refresh(1)" [disabled]="page.pageNumber<=1"></button></li>
    <li class="page-two"><button (click)="refresh((page.pageNumber-1))" [disabled]="page.pageNumber<=1"></button></li>
    <li>
      <b>page</b>
      <input type="number" class="input_li" [(ngModel)]="page.pageNumber" (change)="refresh(page.pageNumber)">
      <b>of {{data.totalPages}}</b>

    </li>
    <li class="page-above"><button (click)="refresh((page.pageNumber+1))" [disabled]="data.number>=data.totalPages-1"></button></li>
    <li class="page-last"><button (click)="refresh(data.totalPages)" [disabled]="data.number>=data.totalPages-1"></button></li>
  </ul>
  <!--<ul  class="page-box"><li><span>{{page.pageNumber}} of {{data.totalPages}}</span></li></ul>-->
</div>
    `,

})
export class Pagination implements OnInit{
  constructor(
  ){}
  //获取父类的变量值
  @Input() page: any = '';
  @Input() data: any = '';

  //反馈到父类
  @Output() pageChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() change= new EventEmitter();
  private currentPage:number;

  //初始化

  ngOnInit(){
  }

  private refresh(page:any):void{
    if(page>this.data.totalPages || page<1){
      this.page.pageNumber=this.data.number+1;
      return;
    }else {
      this.page.pageNumber=page
      this.currentPage=page;
      this.pageChange.emit(this.page);
      this.dataChange.emit(this.data);
      this.change.emit();
    }


  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/pagination/pagination.component.ts